/* Back in Stock — "Notify Me" storefront widget.
   Swaps Add-to-Cart / Buy-Now for a Notify Me button when the selected variant
   is out of stock, and collects an email to POST to the reviews app proxy
   (/apps/reviews/notify-subscribe). Fully decoupled from the theme's product JS:
   it reads availability from the Add-to-Cart button's disabled state (which the
   theme already toggles on variant change) and the current variant id from the
   hidden variant input. */
(function () {
  'use strict';
  if (window.__bisBooted) return;
  window.__bisBooted = true;

  var PROXY_BASE = '/apps/reviews';

  function parseVariants(root) {
    var el = root.querySelector('[data-bis-variants]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  /* ---- Modal (one shared instance) ---- */
  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    var overlay = document.createElement('div');
    overlay.className = 'bis-modal-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="bis-modal" role="dialog" aria-modal="true" aria-labelledby="bis-title">' +
        '<button type="button" class="bis-modal__close" data-bis-close aria-label="Close">&times;</button>' +
        '<div class="bis-modal__body">' +
          '<div class="bis-modal__icon">' +
            '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>' +
          '</div>' +
          '<h3 class="bis-modal__title" id="bis-title">Notify me when available</h3>' +
          '<p class="bis-modal__sub" data-bis-sub>We\'ll email you the moment it\'s back in stock.</p>' +
          '<form class="bis-form" data-bis-form novalidate>' +
            '<label class="bis-field">' +
              '<span>Email address</span>' +
              '<input type="email" name="email" autocomplete="email" placeholder="you@example.com" required>' +
            '</label>' +
            '<div class="bis-error" data-bis-error hidden></div>' +
            '<input type="text" name="homepage_url" class="bis-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
            '<label class="bis-consent">' +
              '<input type="checkbox" name="agreement" required>' +
              '<span>I agree to receive a one-time email when this item is back in stock.</span>' +
            '</label>' +
            '<button type="submit" class="bis-submit" data-bis-submit>Notify me</button>' +
          '</form>' +
          '<div class="bis-success" data-bis-success hidden>' +
            '<div class="bis-success__check"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg></div>' +
            '<h3 data-bis-success-title>You\'re on the list!</h3>' +
            '<p data-bis-success-msg>We\'ll email you as soon as it\'s back.</p>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.hasAttribute('data-bis-close')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });
    overlay.querySelector('[data-bis-form]').addEventListener('submit', onSubmit);

    modal = overlay;
    return overlay;
  }

  var current = null; // { root, productId, variantId, productHandle, productTitle, variantTitle }

  function openModal(ctx) {
    current = ctx;
    var m = ensureModal();
    var form = m.querySelector('[data-bis-form]');
    var success = m.querySelector('[data-bis-success]');
    var errBox = m.querySelector('[data-bis-error]');
    var sub = m.querySelector('[data-bis-sub]');

    form.hidden = false;
    success.hidden = true;
    errBox.hidden = true;
    form.reset();

    sub.textContent = ctx.variantTitle && ctx.variantTitle !== 'Default Title'
      ? 'We\'ll email you the moment "' + ctx.variantTitle + '" is back in stock.'
      : 'We\'ll email you the moment it\'s back in stock.';

    var emailInput = form.querySelector('input[name="email"]');
    if (ctx.prefillEmail) emailInput.value = ctx.prefillEmail;

    m.removeAttribute('hidden');
    document.body.classList.add('bis-lock');
    setTimeout(function () { emailInput.focus(); }, 60);
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('bis-lock');
  }

  function showError(msg) {
    var errBox = modal.querySelector('[data-bis-error]');
    errBox.textContent = msg;
    errBox.hidden = false;
  }

  function showSuccess(already) {
    var form = modal.querySelector('[data-bis-form]');
    var success = modal.querySelector('[data-bis-success]');
    form.hidden = true;
    success.hidden = false;
    success.querySelector('[data-bis-success-title]').textContent =
      already ? "You're already on the list" : "You're on the list!";
    success.querySelector('[data-bis-success-msg]').textContent =
      already ? "We already have your email for this item." : "We'll email you as soon as it's back.";
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (!current) return;
    var form = e.currentTarget;
    var btn = form.querySelector('[data-bis-submit]');
    var email = form.querySelector('input[name="email"]').value.trim();
    var agree = form.querySelector('input[name="agreement"]').checked;
    var honeypot = form.querySelector('input[name="homepage_url"]').value;
    var errBox = modal.querySelector('[data-bis-error]');
    errBox.hidden = true;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError('Please enter a valid email address.'); return; }
    if (!agree) { showError('Please tick the box to be notified.'); return; }

    btn.disabled = true;
    btn.classList.add('is-loading');
    var original = btn.textContent;
    btn.textContent = 'Submitting…';

    try {
      var res = await fetch(PROXY_BASE + '/notify-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: current.productId,
          variant_id: current.variantId,
          product_handle: current.productHandle,
          product_title: current.productTitle,
          variant_title: current.variantTitle,
          contact: email,
          agreement: true,
          customer_id: current.customerId || null,
          homepage_url: honeypot,
          locale: (document.documentElement.lang || '').slice(0, 12)
        })
      });
      var data = await res.json().catch(function () { return {}; });

      if (res.ok && data.ok) { showSuccess(!!data.already); return; }
      if (res.status === 409 && data.error === 'in_stock') {
        showError('Good news — this item is back in stock! Refresh the page to buy it.');
      } else if (data.errors && data.errors.contact) {
        showError(data.errors.contact);
      } else if (data.error === 'rate_limited') {
        showError('Too many requests. Please try again in a little while.');
      } else if (data.error === 'disabled') {
        showError('Back-in-stock alerts are currently turned off for this store.');
      } else {
        showError('Something went wrong. Please try again.');
      }
    } catch (err) {
      showError('Network error. Please check your connection and try again.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = original;
    }
  }

  /* ---- Per-section wiring ---- */
  function initRoot(root) {
    if (root.__bisInit) return;
    root.__bisInit = true;

    var atc = root.querySelector('.product-main__btn--add-to-cart');
    var variantInput = root.querySelector('[data-variant-id]');
    var notifyBtn = root.querySelector('[data-bis-open]');
    if (!atc || !notifyBtn) return;

    var variants = parseVariants(root);

    function currentVariantId() {
      return variantInput ? String(variantInput.value || '') : '';
    }

    // Availability source of truth = the theme's own ATC disabled state.
    function sync() {
      var vid = currentVariantId();
      var info = variants[vid];
      var available = info ? !!info.available : !atc.disabled;
      root.classList.toggle('bis-oos', !available);
    }

    // The theme toggles ATC.disabled + text on variant change; observe that.
    var mo = new MutationObserver(sync);
    mo.observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });

    notifyBtn.addEventListener('click', function () {
      var vid = currentVariantId();
      var info = variants[vid] || {};
      openModal({
        root: root,
        productId: root.getAttribute('data-bis-product-id'),
        variantId: vid,
        productHandle: root.getAttribute('data-bis-product-handle'),
        productTitle: root.getAttribute('data-bis-product-title'),
        variantTitle: info.title || '',
        prefillEmail: root.getAttribute('data-bis-customer-email') || '',
        customerId: root.getAttribute('data-bis-customer-id') || ''
      });
    });

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-bis-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
